// ** MUI Imports
import { styled, useTheme } from '@mui/material/styles'
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer'

const SwipeableDrawer = styled(MuiSwipeableDrawer)({
  overflowX: 'hidden',
  transition: 'width .25s ease-in-out',
  '& ul': {
    listStyle: 'none'
  },
  '& .MuiListItem-gutters': {
    paddingLeft: 4,
    paddingRight: 4
  },
  '& .MuiDrawer-paper': {
  left: 'unset',
  right: 'unset',
  overflowX: 'hidden',
  transition: 'width .25s ease-in-out, box-shadow .25s ease-in-out',
  backgroundColor: '#FFFFFF',
  borderRadius: '12px',
  boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
  border: 'none',
  marginBottom: '16px',
  position: 'fixed',
  top: 0,
  
  // apply only when screen size > 1200px
  [`@media (min-width:1200px)`]: {
    marginTop: '90px', // Align with header height
    height: 'calc(100vh - 96px)', // Subtract header height + margin
  }
}
})

const Drawer = props => {
  // ** Props
  const {
    hidden,
    children,
    navHover,
    navWidth,
    settings,
    navVisible,
    setNavHover,
    setNavVisible,
    collapsedNavWidth,
    navigationBorderWidth
  } = props

  // ** Hook
  const theme = useTheme()

  // ** Vars
  const { skin, navCollapsed } = settings

  const drawerColor = () => {
    return {
      '& .MuiTypography-root, & .MuiSvgIcon-root': {
        color: '#666666'
      }
    }
  }

  const drawerBgColor = () => {
    return {
      backgroundColor: '#FFFFFF'
    }
  }

  // Drawer Props for Mobile & Tablet screens
  const MobileDrawerProps = {
    open: navVisible,
    onOpen: () => setNavVisible(true),
    onClose: () => setNavVisible(false),
    ModalProps: {
      keepMounted: true // Better open performance on mobile.
    }
  }

  // Drawer Props for Desktop screens
  const DesktopDrawerProps = {
    open: true,
    onOpen: () => null,
    onClose: () => null,
    onMouseEnter: () => {
      setNavHover(true)
    },
    onMouseLeave: () => {
      setNavHover(false)
    }
  }

  return (
    <SwipeableDrawer
      className='layout-vertical-nav'
      variant={hidden ? 'temporary' : 'permanent'}
      {...(hidden ? { ...MobileDrawerProps } : { ...DesktopDrawerProps })}
      PaperProps={{ sx: { width: navCollapsed && !navHover ? collapsedNavWidth : navWidth } }}
      sx={{
        width: navCollapsed ? collapsedNavWidth : navWidth,
        '& .MuiDrawer-paper': {
          ...drawerColor(),
          ...drawerBgColor(),
          ...(!hidden && navCollapsed && navHover ? { boxShadow: 9 } : {}),
          borderRight: 0,
        }
      }}
    >
      {children}
    </SwipeableDrawer>
  )
}

export default Drawer
